module.exports = __webpack_public_path__ + "images/檀程长图_07.jpg?v=4544e971";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_07.jpg
 ** module id = 197
 ** module chunks = 1 2
 **/